import exodusInstance from 'lib/api/instances/exodus';
import { APIResponse } from '../../../../@types/api-response';
import configEndpoint from '../constants/apiEndpoints/config';
import { VirtualFormulaResponse } from '../types/api/formula';
import {
  VirtualCancelRequestBody,
  VirtualCancelResponse,
} from '../types/api/cancel';

const { defaultInstance } = exodusInstance;

export const getFormula = (): Promise<APIResponse<VirtualFormulaResponse>> =>
  defaultInstance.get(configEndpoint.formula);

export const postCancel = (
  requestBody: VirtualCancelRequestBody,
): Promise<APIResponse<VirtualCancelResponse>> =>
  defaultInstance.post(configEndpoint.cancel, requestBody);
